import { SET_SUGGESTIONS, SELECT_SUGGESTION } from "../actionTypes";
import { handleActions } from 'redux-actions';

const initialState = {
  suggestions: [],
  selected: {
    pick_up: {},
    drop_off: {}
  },
};

const commonReducer = handleActions (
  {
    [SET_SUGGESTIONS]: (state, { payload }) => ({
      ...state,
      suggestions: payload
    }),
    [SELECT_SUGGESTION]: (state, { payload }) => ({
      ...state,
      selected: {
        ...state.selected,
        [payload.key]: payload.suggestion
      }
    })
  },
  initialState
);

export default commonReducer;